import { render } from "./ScenarioHeader.vue?vue&type=template&id=4f717e9d"
import script from "./ScenarioHeader.vue?vue&type=script&lang=js"
export * from "./ScenarioHeader.vue?vue&type=script&lang=js"
script.render = render

export default script